export const LABELS = {
	heading: 'Reviews For This Product',
	subHeading: 'All reviews are from qualified Social Nature shoppers.',
	starRating: 'Average Rating',
	verifiedLabel: 'Verified',
	viewAllProducts: 'View all reviews for this product'
};
